module.exports = __webpack_public_path__ + "static/media/remboursement_ccm.4dcf9988.png";